// src/api/tiendaConfig.js
import axios from 'axios';
import { API } from './URL_API';

const API_URL = `${API}/api/links`;
const API_BASE_URL = `${API}/api`;

export const fetchSocialLinks = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error al obtener los enlaces:', error);
        throw error;
    }
};

export const sendSocialLinkToBackend = async (link) => {
    try {
        const response = await axios.post(API_URL, link);
        if (response.status !== 201) throw new Error('Error al enviar el enlace social');
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const updateSocialLinkInBackend = async (link) => {
    try {
        const response = await axios.put(`${API_URL}/${link.id}`, link);
        if (response.status !== 200) throw new Error('Error al actualizar el enlace social');
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const deleteSocialLinkFromBackend = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`);
        if (response.status !== 200) throw new Error('Error al eliminar el enlace social');
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

// Obtener el link de WhatsApp
export const getWhatsappLink = async () => {
    const response = await axios.get(`${API_BASE_URL}/whatsapp-link`);
    return response.data;
};

// Crear el link de WhatsApp
export const createWhatsappLink = async (data) => {
    const response = await axios.post(`${API_BASE_URL}/whatsapp-link`, data);
    return response.data;
};

// Actualizar el link de WhatsApp
export const updateWhatsappLink = async (id, data) => {
    const response = await axios.put(`${API_BASE_URL}/whatsapp-link/${id}`, data);
    return response.data;
};

// Eliminar el link de WhatsApp
export const deleteWhatsappLink = async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/whatsapp-link/${id}`);
    return response.data;
};

